"use strict";

/**
 * StyleSheet
 */
import "./assets/sass/style.scss";
/**
 * Main core files
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
/**
 * Init Vuex and load main store module for Vuex
 */
import store from "./store";

/**
 * 3rd Party Libraries
 * https://bootstrap-vue.js.org/
 * https://vcalendar.io/
 * https://logaretm.github.io/vee-validate/
 * https://github.com/mercs600/vue2-perfect-scrollbar
 * https://lodash.com/docs/
 * https://github.com/hilongjw/vue-progressbar
 * https://vuejsexamples.com/simple-lightbox-component-for-vue-applications/
 * https://vue-multiselect.js.org/#sub-getting-started
 */
import BootstrapVue from "bootstrap-vue";
import VCalendar from 'v-calendar';
import {
  ValidationObserver,
  ValidationProvider,
  extend
} from "vee-validate";
import VueProgressBar from 'vue-progressbar'
import * as rules from "vee-validate/dist/rules";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import Lightbox from 'vue-my-photos'
import VueMobileDetection from "vue-mobile-detection";
import _ from 'lodash/core';
import Multiselect from 'vue-multiselect'
//--API
import ApiService from "./services/api.service";
//-- Token
import {
  TokenService
} from "./services/storage.service";

/**
 * Start pre-launch operations
 */

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeaderAuth();
  ApiService.mount401Interceptor();

}

if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = true;
}

/**
 * Extend Vee-Validation
 */
extend("password", {
  params: ["target"],
  validate(value, {
    target
  }) {
    return value === target;
  },
  message: "Password confirmation does not match"
});

/**
 * END pre-launch operations
 */

/**
 * Register or retrieve a global component
 * https://vuejs.org/v2/api/#Vue-component
 */
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component('lightbox', Lightbox);
Vue.component('multiselect', Multiselect)


/**
 * Install a Vue.js plugin
 * https://vuejs.org/v2/api/#Vue-use
 */
Vue.use(BootstrapVue);
Vue.use(PerfectScrollbar);
Vue.use(VueMobileDetection);
Vue.use(VueProgressBar, {
  thickness: '5px'
});
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {});
//TODO: make a plugins for this
Object.defineProperty(Vue.prototype, '$_', {
  value: _
});

/**
 * Init vue instance
 */
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#dashboard");
